import { IBookInfo } from "@/domain/entities/book";
import { BookIntervalCode, CalendarEventInfo } from "@/types";

export function useConvertBookInfoToEventList(
  bookInfos: IBookInfo[]
): CalendarEventInfo<IBookInfo>[] {
  // 달력화면에는 일예약만 표시되므로 월예약은 필터를 통해 제거한다.
  const dailyBookInfos = bookInfos.filter(
    (bookInfo) => bookInfo.bookIntervalCode !== BookIntervalCode.MONTH
  );

  const calendarEventInfosMap = new Map<
    string,
    { bookStatusMap: Map<string, number>; detailEvents: IBookInfo[] }
  >();

  dailyBookInfos.forEach((bookInfo) => {
    if (!calendarEventInfosMap.has(bookInfo.boardDate)) {
      calendarEventInfosMap.set(bookInfo.boardDate, {
        bookStatusMap: new Map<string, number>(),
        detailEvents: [],
      });
    }

    const { bookStatusMap, detailEvents } = calendarEventInfosMap.get(
      bookInfo.boardDate
    )!;

    detailEvents.push(bookInfo);

    const bookStatus = bookInfo.bookStatus;
    if (bookStatusMap.has(bookStatus)) {
      bookStatusMap.set(bookStatus, bookStatusMap.get(bookStatus)! + 1);
    } else {
      bookStatusMap.set(bookStatus, 1);
    }
  });

  const calendarEventInfos = Array.from(
    calendarEventInfosMap,
    ([date, { bookStatusMap, detailEvents }]) => ({
      date,
      eventTitles: Array.from(bookStatusMap, ([status, count]) =>
        count > 1 ? `${status} ${count}` : status
      ),
      detailEvents,
    })
  );

  return calendarEventInfos;
}
